export var SDK_NAME = 'sentry.javascript.browser';
export var SDK_VERSION = '5.15.5';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/browser/esm/version.js
// module id = 196
// module chunks = 0